import { WaybillComponent } from "./waybill/waybill.component";
import { WaybillListComponent } from "./waybill/waybill-list/waybill-list.component";
import { Routes } from "@angular/router";
import { SystemComponent } from "./system.component";
import { AuthGuard } from "./shared/auth.guard";

import { WorkOrderListComponent } from "./work-order/work-order-list/work-order-list.component";
import { NewWorkOrderComponent } from "./work-order/new-work-order/new-work-order.component";
import { WorkOrderComponent } from "./work-order/work-order.component";
import { InternalWorkOrderComponent } from "./work-order/internal-work-order/internal-work-order.component";
import { BudgetComponent } from "./budget/budget.component";
import { NewBudgetComponent } from "./budget/new-budget/new-budget.component";
import { BudgetListComponent } from "./budget/budget-list/budget-list.component.";
import { BillingComponent } from "./billing/billing.component";
import { BillingListComponent } from "./billing/billing-list/billing-list.component";
import { NewBillingComponent } from "./billing/new-billing/new-billing.component";
import { ApprobationGroupComponent } from "./approbation-group/approbation-group.component";
import { ApprobationGroupDetailComponent } from "./approbation-group/approbation-group-detail/approbation-group-detail.component";
import { ProviderComponent } from "./provider/provider.component";
import { BuyOrderComponent } from "./buy-order/buy-order.component";
import { NewBuyOrderComponent } from "./buy-order/new-buy-order/new-buy-order.component";
import { BuyOrderListComponent } from "./buy-order/buy-order-list/buy-order-list.component";

import { RetentionComponent } from "./retention/retention.component";
import { NewRetentionComponent } from "./retention/new-retention/new-retention.component";
import { RetentionListComponent } from "./retention/retention-list/retention-list.component";


const workOrderRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  {
    path: "list",
    component: WorkOrderListComponent,
  },

  {
    path: "list-1",
    component: WorkOrderListComponent,
  },
  {
    path: "list-2",
    component: WorkOrderListComponent,
  },
  { path: "list/:jwt", component: BuyOrderListComponent },
  { path: "new", component: NewWorkOrderComponent },
  { path: "edit/:id", component: NewWorkOrderComponent },
  {
    path: "internal-work-order/new/:idWorkOrder",
    component: InternalWorkOrderComponent,
  },
  {
    path: "internal-work-order/edit/:idWorkOrder/:idInternalWorkOrder",
    component: InternalWorkOrderComponent,
  },
  { path: "budget-list/:id", component: BudgetListComponent },
];
const budgetRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: BudgetListComponent },
  { path: "new/:otid/:budgetselect", component: NewBudgetComponent },
  { path: "new/:otid", component: NewBudgetComponent },
  { path: "edit/:otid/:id", component: NewBudgetComponent },
  { path: "edit/:otid/:id/:jwt", component: NewBudgetComponent },
];

const billingRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: BillingListComponent },
  { path: "new/:budid", component: NewBillingComponent },
  { path: "edit/:budid/:id", component: NewBillingComponent },
];

const buyOrderRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: BuyOrderListComponent },
  { path: "new", component: NewBuyOrderComponent },
  { path: "edit/:id", component: NewBuyOrderComponent },
  { path: "new/:bhid", component: NewBuyOrderComponent },
];

const retentionRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: RetentionListComponent },
  { path: "new", component: NewRetentionComponent },
  { path: "edit/:id", component: NewRetentionComponent },
  { path: "new/:bhid", component: NewRetentionComponent },
];
const waybillRoutes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: WaybillListComponent },
];

const childSystemRoutes: Routes = [
  { path: "", redirectTo: "work-order", pathMatch: "full" },
  {
    path: "work-order",
    component: WorkOrderComponent,
    children: workOrderRoutes,
  },
  { path: "billing", component: BillingComponent, children: billingRoutes },
  { path: "budget", component: BudgetComponent, children: budgetRoutes },
  { path: "approbation-group", component: ApprobationGroupComponent },
  {
    path: "approbation-group/detail",
    component: ApprobationGroupDetailComponent,
  },
  {
    path: "approbation-group/detail/:id",
    component: ApprobationGroupDetailComponent,
  },
  { path: "provider", component: ProviderComponent },
  { path: "buy-order", component: BuyOrderComponent, children: buyOrderRoutes },

  { path: "retention", component: RetentionComponent, children: retentionRoutes },
  { path: "waybill", component: WaybillComponent, children: waybillRoutes },
];

export const systemRoutes: Routes = [
  {
    path: "system",
    component: SystemComponent,
    children: childSystemRoutes,
    canActivate: [AuthGuard],
  },
];



// WEBPACK FOOTER //
// ./src/app/system/system.routes.ts